import React from 'react';
type SvgProps = {
    size: number;
    color: string;
};

const Logout: React.FC<SvgProps> = ({ size, color }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M2.68483 0.695312H18.6759C19.9324 0.695312 20.9604 1.72331 20.9604 2.97976V18.9709C20.9604 20.2273 19.9324 21.2553 18.6759 21.2553H2.68483C1.41697 21.2553 0.400391 20.2273 0.400391 18.9709V14.402H2.68483V18.9709H18.6759V2.97976H2.68483V7.54865H0.400391V2.97976C0.400391 1.72331 1.41697 0.695312 2.68483 0.695312ZM10.1093 16.6864L8.49875 15.0759L11.4457 12.1175H0.400391V9.83309H11.4457L8.49875 6.87473L10.1093 5.2642L15.8204 10.9753L10.1093 16.6864Z" fill={color} />
        </svg>
    );
};

export default Logout;
